import { render, staticRenderFns } from "./tabsPreview.vue?vue&type=template&id=33f32158&scoped=true"
import script from "./tabsPreview.vue?vue&type=script&lang=js"
export * from "./tabsPreview.vue?vue&type=script&lang=js"
import style0 from "./tabsPreview.vue?vue&type=style&index=0&id=33f32158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f32158",
  null
  
)

export default component.exports